import React, { useState, useRef } from 'react';

import cx from 'classnames';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

import Tooltip, { TooltipText } from 'components/shared/Tooltip';
import generateRandomString from 'utils/generateRandomString';

import s from './index.module.css';

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

function TruncatedText(props) {
  const [id] = useState(generateRandomString(6));
  const { text, className, lines = 2 } = props;
  const [isTextTruncated, setIsTextTruncated] = useState(false);
  const ref = useRef(null);

  const handleReflow = (rleState) => setIsTextTruncated(rleState.clamped);

  if (!text) return null;

  const updatedText = text.replace(/(\r\n|\n|\r)/gm, ' ');
  const blockClasses = cx({
    [s.text]: lines > 1,
    className,
  });

  return (
    <div className={blockClasses} ref={ref} data-tip data-for={`truncatedCell__${id}`}>
      <ResponsiveEllipsis
        text={updatedText}
        maxLine={lines}
        ellipsis="…"
        trimRight
        basedOn="words"
        onReflow={handleReflow}
      />

      <Tooltip place="bottom" id={`truncatedCell__${id}`} withMouseOver disable={!isTextTruncated}>
        <TooltipText className={s.tooltipText}>{text}</TooltipText>
      </Tooltip>
    </div>
  );
}

export default TruncatedText;
